import React from "react";
import { graphql, StaticQuery } from "gatsby";

import Helmet from "react-helmet";

const MetaTags = (props) => {
  const { pageTitle, pageMeta, defaultMeta } = props;

  // Check for page meta or use the default
  const metadata = pageMeta ? { ...pageMeta } : { ...defaultMeta };

  // If there is a page title but no meta write the title
  if (pageTitle && !pageMeta) metadata.title = `BIGSTAR - ${pageTitle}`;

  // If there is page meta use that title & Append BIGSTAR
  if (pageMeta) metadata.title = `BIGSTAR - ${pageMeta.pageTitle}`;

  return (
    <Helmet htmlAttributes={{ lang: "en" }}>
      <title>{metadata.title}</title>

      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />

      <meta name="description" content={metadata.description.description}></meta>

      <meta property="og:title" content={`${metadata.title}`} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metadata.socialImage.file.url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="https://bgstr.com" />
      <meta name="twitter:title" content={`${metadata.title}`} />
    </Helmet>
  );
};

export default function Meta({ pageTitle, pageMeta }) {
  return (
    <StaticQuery
      query={graphql`
        query {
          contentfulPageMeta(id: { eq: "792afa4c-aab1-553f-b96e-49f0d5ad3909" }) {
            ...DefaultMeta
          }
        }
      `}
      render={(data) => (
        <MetaTags pageTitle={pageTitle} pageMeta={pageMeta} defaultMeta={data.contentfulPageMeta} />
      )}
    />
  );
}
